import React from "react";

export function AccessPermitsList(props) {
    const { ids, items } = props;

    if (!items) {
        return null;
    }
    if (ids.length === 0) {
        return <span className="text-muted">Отсутствуют</span>;
    }

    const filtered = items.filter((item) => ids.includes(item.id));

    return filtered.map((item) => (
        <div key={item.id}>
            {item.image?.accessUrlLink && (
                <img className="mr-1" src={item.image?.accessUrlLink} width={20} alt={item.name || ""} />
            )}
            <small>{item.name}</small>
        </div>
    ));
}
